import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetMultipleRandomBlogPost } from '../services/apiservice';

const RandomContent = () => {
    const navigate = useNavigate();
    const [blogPost, setBlogPost] = useState([]);
    const [loading, setLoading] = useState(true);
    const handleBlogClick = () => navigate('/blog/:paramlink');
    
    // Initialize carousel after blog posts load and render
    useEffect(() => {
        if (!loading && window.$ && window.$('.breaking-news-slider').owlCarousel) {
            window.$('.breaking-news-slider').owlCarousel({
                items: 1,
                loop: true,
                nav: false,
                dots: false,
                autoplay: true,
                autoplayHoverPause: true,
                margin: 30,
                autoplaySpeed: 1000,
                animateOut: "slideOutDown",
                animateIn: "slideInDown"
            });
        }
    }, [loading]);

    const fillRandomContent = async () => {
        try {
            const postList = await GetMultipleRandomBlogPost();
            const jsonPostList = JSON.parse(postList);
            setBlogPost(jsonPostList);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching the data:', error);
        }
    }

    useEffect(() => {
        fillRandomContent();
    }, []);

    if (loading) {
        return null;  // render nothing while loading
    }

    return (
        <div className="breaking-news-area">
            <div className="container-fluid">
                <div className="breaking-news-content">
                    <span>Blog Highlights</span>
                    <div className="breaking-news-slider owl-carousel owl-theme">
                        {blogPost.map((post, index) => (
                            <a key={index} href={"/blog/" + post.paramlink} onClick={handleBlogClick}>
                                <p>{post.title}</p>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RandomContent;
